<template>
    <div>
        <DekstopPortfolioDetail v-if="!isMobile" />
        <MobilePortfolioDetail v-if="isMobile" />
    </div>
  </template>
  
  <script>
  import DekstopPortfolioDetail from "@/components/portfolio/detail/desktop/Detail.vue"
  import MobilePortfolioDetail from "@/components/portfolio/detail/mobile/Detail.vue"
  
  export default {
    components: {
        DekstopPortfolioDetail,
        MobilePortfolioDetail,
    },
    data() {
        return {
            isMobile: false,
        };
    },
    methods: {
        handleView() {
            this.isMobile = window.innerWidth <= 990;
        },
    },
    mounted() {
        this.$gtag.pageview(this.$route);
        this.$utils.scrollTop()
    },
    beforeMount() {
        this.handleView();
    },
  };
  </script>